module.exports = __webpack_public_path__ + "img/79.3.TP.ce01119b.png";